module.exports = __webpack_public_path__ + "assets/img/testi3.d472f12b.jpg";